var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "378px",
    height: "378px",
    viewBox: "0 0 378 378",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Instagram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.16 377.97 0.16 377.97 376 0 376"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Instagram",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.4996,254.84 C153.9306,254.84 124.9996,225.91 124.9996,190.34 C124.9996,154.77 153.9306,125.84 189.4996,125.84 C225.0696,125.84 253.9996,154.77 253.9996,190.34 C253.9996,225.91 225.0696,254.84 189.4996,254.84 M189.4996,90.84 C134.6406,90.84 89.9996,135.48 89.9996,190.34 C89.9996,245.2 134.6406,289.84 189.4996,289.84 C244.3596,289.84 288.9996,245.2 288.9996,190.34 C288.9996,135.48 244.3596,90.84 189.4996,90.84",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.9996,88.34 C313.9996,101.59 303.2496,112.34 289.9996,112.34 C276.7396,112.34 265.9996,101.59 265.9996,88.34 C265.9996,75.09 276.7396,64.34 289.9996,64.34 C303.2496,64.34 313.9996,75.09 313.9996,88.34",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 0.840000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.9996,267.5 C342.9996,308.03 310.0296,341 269.4996,341 L108.4996,341 C67.9706,341 34.9996,308.03 34.9996,267.5 L34.9996,108.5 C34.9996,67.97 67.9706,35 108.4996,35 L269.4996,35 C310.0296,35 342.9996,67.97 342.9996,108.5 L342.9996,267.5 Z M275.3906,0.16 L102.6096,0.16 C45.5106,3.22 -0.0004,50.64 -0.0004,108.5 L-0.0004,267.5 C-0.0004,327.33 48.6696,376 108.4996,376 L269.4996,376 C328.6296,376 376.8596,328.46 377.9706,269.6 L377.9706,106.4 C376.8996,49.5 331.7996,3.19 275.3906,0.16 L275.3906,0.16 Z",
    id: "Fill-5",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/INSTAGRAM.2de34199cb685fd1bc98369bcfe8d481.svg";
export { ForwardRef as ReactComponent };